import type { ImageCardsCropMeta } from './useImageCardsSplit';

/**
 * Hand-off for "Adjust crop" metadata that arrives with a pasted screenshot's
 * sections (hero images cropped out of it), keyed by the new block's id. The
 * paste flow drops it here; the block's editor takes it once mounted, which is
 * when the block is really on the page. Entries for sections the user never
 * inserted are simply never taken.
 */
const pending = new Map<string, ImageCardsCropMeta>();

export function rememberPastedCropMeta(byBlockId?: Record<string, ImageCardsCropMeta>): void {
  for (const [blockId, meta] of Object.entries(byBlockId ?? {})) pending.set(blockId, meta);
}

/** The crop metadata waiting for this block, removed as it is taken. */
export function takePastedCropMeta(blockId: string): ImageCardsCropMeta | undefined {
  const meta = pending.get(blockId);
  pending.delete(blockId);
  return meta;
}
